import { env } from "env"
/**
 * - Toggle `true` or `false` to display values when debugging different parts of the application.
 * - Adjust `VITE_ENABLE_LOGGING` in .env to show or hide logs on prod.
 */
export const SHOW_LOGS = {
  ADB2C_TOKEN: false,
  API_ROUTE: false,
  APP_JSON: true,
  CLIENT_ID: false,
  ENVIRONMENT: false,
  INITIAL_USER_VALUES: false,
  MSAL: false,
  TEALIUM: false,
  UPDATED_USER_FORM_VALUES: false,
  USER_EMAIL: false,
  USER_EXISTS: false,
  USER_TOKEN: false,
}

export const log = (condition: boolean, ...args: unknown[]) => {
  if ((!env.DEV || env.VITE_ENABLE_LOGGING === "true") && condition) {
    console.log(...args)
  }
}

export const logGroup = (
  condition: boolean,
  groupLabel: string,
  ...args: any[]
) => {
  if ((!env.DEV || env.VITE_ENABLE_LOGGING === "true") && condition) {
    console.groupCollapsed(groupLabel)
    console.log(...args)
    console.groupEnd()
  }
}
